import { useContext, useEffect, useState } from 'react';
import GlobalGrid from '../../../components/GlobalGrid';
import {
  DropDownList,
  DropDownListComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { getGlobalFilter } from '../../../services/GlobalFilter/GlobalFilterServices';
import Message from '../../../utils/Message/Message';
import { getTrades } from '../../../services/tradeperson/trades';
import GlobalDialog from '../../../components/GlobalDialog';
import { Column, GridComponent } from '@syncfusion/ej2-react-grids';
import { TextBox, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { BsSearch } from 'react-icons/bs';
import { ThemeContext } from '../../../context/theme.context';
import { preparingTemplatePoint } from '../../../utils/OperationPreparingForTemplate';
const toolbarOptionsForDetail: any = [
  'Add',
  'Edit',
  'Delete',
  'Update',
  'Cancel',
];
let isRenderBegin: boolean = false;
let tempGrid: GridComponent;
let orderDList: DropDownListComponent;
var the_current_query: string = '';
var resultLikeQuery = '';
var theQuerySearch = '';
var searchText: string = '';
interface IProps {
  isWorkorderSide?: boolean;
  order_detail?: any;
}
function OperationTemplate({ isWorkorderSide, order_detail }: IProps) {
  let tradeElem: any;
  let tradeObj: any;
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const erpTypeName = 'MEX';
  const [current_query, setCurrent_query] = useState('');
  const [tradeData, setTradeData] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [currentTempId, setCurrentTempId] = useState<number>(-1);
  const [currentTempName, setCurrentTempName] = useState('');
  const [statusData, setStatusData] = useState();
  const context = useContext(ThemeContext);
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='operation-template'
          autocomplete='off'
          input={inputEnterPress}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search}
          />
        </div>
      </div>
    );
  };
  const toolbarOptions: any = [
    {
      text: 'Detail',
      tooltipText: '',
      prefixIcon: 'e-list-ordered',
      id: 'detail',
    },
    { template: template, align: 'Right' },
  ];
  if (isWorkorderSide) {
    toolbarOptions.push({
      text: 'Apply to Workorder',
      tooltipText: '',
      prefixIcon: 'e-apply',
      id: 'apply',
    });
  }
  let statusElem: any;
  let statusObj: any;
  let pmIdElem: any;
  let pmIdObj: any;
  let pmTextElem: any;
  let pmTextObj: any;
  const tradeParams = {
    create: () => {
      tradeElem = document.createElement('input');
      return tradeElem;
    },
    destroy: () => {
      tradeObj.destroy();
    },
    read: () => {
      return tradeObj.text;
    },
    write: (args: any) => {
      tradeObj = new DropDownList({
        change: () => {},
        dataSource: tradeData,
        fields: { text: 'trade_code', value: 'trade_id' },
        floatLabelType: 'Never',
        placeholder: 'Select a Trade',
        allowFiltering: true,
        text: args.rowData.trade_code,
      });
      tradeObj.appendTo(tradeElem);
    },
  };
  const pmIDParams = {
    create: () => {
      pmIdElem = document.createElement('input');
      return pmIdElem;
    },
    destroy: () => {
      pmIdObj.destroy();
    },
    read: () => {
      return pmIdObj.value;
    },
    write: (args: any) => {
      pmIdObj = new TextBox({
        change: () => {},
        enabled: false,
        floatLabelType: 'Never',
        value: currentTempId.toString(),
      });
      pmIdObj.appendTo(pmIdElem);
    },
  };
  const pmTextParams = {
    create: () => {
      pmTextElem = document.createElement('input');
      return pmTextElem;
    },
    destroy: () => {
      pmTextObj.destroy();
    },
    read: () => {
      return pmTextObj.value;
    },
    write: (args: any) => {
      pmTextObj = new TextBox({
        change: () => {},
        enabled: false,
        floatLabelType: 'Never',
        value: currentTempName,
      });
      pmTextObj.appendTo(pmTextElem);
    },
  };
  const statusParams = {
    create: () => {
      statusElem = document.createElement('input');
      return statusElem;
    },
    destroy: () => {
      statusObj.destroy();
    },
    read: () => {
      return statusObj.value;
    },
    write: (args: any) => {
      statusObj = new DropDownList({
        change: () => {},
        dataSource: statusData,
        fields: { value: 'value', text: 'alias' },
        placeholder: 'Select a status',
        enabled: true,
        showClearButton: true,
        filterBarPlaceholder: 'Search a status',
        floatLabelType: 'Never',
        allowFiltering: true,
        value: args.rowData.status_code,
      });
      statusObj.appendTo(statusElem);
    },
  };
  const theColumnOperations = [
    {
      field: 'id',
      headerText: 'ID',
      width: 60,
      clipMode: 'EllipsisWithTooltip',
      isPrimaryKey: true,
      allowEditing: false,
      visible: false,
    },
    // {
    //   field: 'transaction_id',
    //   headerText: 'PM ID',
    //   clipMode: 'EllipsisWithTooltip',
    //   allowEditing: true,
    //   edit: pmIDParams,
    // },
    {
      field: 'template_id',
      headerText: 'PM ID',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: pmIDParams,
      width: 50,
    },
    {
      field: 'description',
      headerText: 'Template Description',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: pmTextParams,
    },
    {
      field: 'operation_sequence',
      headerText: 'Operation Sequence',
      editType: 'numericedit',
      width: 90,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      validationRule: { required: true, number: true },
      edit: { params: { min: 0, max: 10000 } },
    },
    {
      field: ERP_TYPE === erpTypeName ? 'operation_description' : 'long_description',
      headerText: 'Description',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },

    
    {
      field: 'trade_code',
      headerText: 'Trade',
      width: 80,
      clipMode: 'EllipsisWithTooltip',
      edit: tradeParams,
    },
    {
      field: 'est_hours',
      headerText: 'Est Hours',
      editType: 'numericedit',
      width: 90,
      clipMode: 'EllipsisWithTooltip',
      format: 'C2',
      allowEditing: true,
      edit: { params: { min: 0, max: 10000 } },
    },
    {
      field: 'required',
      headerText: 'Required',
      editType: 'numericedit',
      width: 90,
      clipMode: 'EllipsisWithTooltip',
      format: 'C2',
      allowEditing: true,
      edit: { params: { min: 1, max: 10000 } },
    },
    {
      field: 'duration',
      headerText: 'Duration',
      editType: 'numericedit',
      width: 90,
      clipMode: 'EllipsisWithTooltip',
      format: 'C2',
      allowEditing: true,
      edit: { params: { min: 1, max: 10000 } },
    },
    {
      allowEditing: true,
      field: 'status_code',
      headerText: 'Status',
      width: 40,
      clipMode: 'EllipsisWithTooltip',
      edit: statusParams,
    },
  ];
  const theColumns: any = [
    {
      field: 'pm_id',
      headerText: 'PM ID',
      isPrimaryKey: true,
      allowEditing: false,
    },
    {
      field: 'description',
      headerText: 'Description',
      allowEditing: false,
    },
  ];
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const search = () => {
    if (current_query !== '' || searchText !== '') {
      buildQuery();
    }
  };
  const buildQuery = () => {
    the_current_query = current_query;
    the_current_query = the_current_query.replace(the_current_query, '');
    the_current_query = the_current_query.replace(theQuerySearch, '');
    if (searchText !== '') {
      theQuerySearch = '$' + searchText;
      the_current_query = the_current_query + theQuerySearch;
    }
    setCurrent_query(the_current_query);
  };
  const getTrade = () => {
    getTrades().then((result) => {
      setTradeData(result.data);
    });
  };
  useEffect(() => {
    $('#operation-template').val(searchText);
  });

  useEffect(() => {
    isRenderBegin = true;
    getTrade();
    getGlobalFilters();
    return () => {
      isRenderBegin = false;
    };
  }, []);
  const getGlobalFilters = () => {
    getGlobalFilter('operation$status$isEnabled€1')
      .then((res) => {
        setStatusData(res.data);
      })
      .catch(() => {
        console.log('Error when get status');
      });
  };
  const extendsToolbarClick = (args: any) => {
    if (args.item.id === 'detail') {
      if (tempGrid?.getSelectedRecords().length > 0) {
        let theData = tempGrid?.getSelectedRecords()[0] as any;
        setCurrentTempId(theData.pm_id);
        setCurrentTempName(theData.description);
        setShowDialog(true);
      }
    }
    if (args.item.id === 'apply') {
      if (tempGrid?.getSelectedRecords().length > 0) {
        let theData = tempGrid?.getSelectedRecords()[0] as any;
        setCurrentTempId(theData.pm_id);
        setCurrentTempName(theData.description);
        if (isWorkorderSide) {
          if (order_detail) {
            preparingTemplatePoint(order_detail, theData.pm_id);
          } else {
            Message.error('No workorder to procced');
          }
        } else {
        }
      }
    }
  };
  const onCreated = (ref: GridComponent) => {
    tempGrid = ref;
  };
  const queryCellInfo = (args: any) => {
    if (args.column.field === 'long_description') {
      args.cell.setAttribute('style', `color:#9fb8dd;`);
    }
    if (
      args.column.field === 'est_hours' ||
      args.column.field === 'duration' ||
      args.column.field === 'required'
    ) {
      args.cell.innerHTML = Number(args.cell.innerHTML).toFixed(2);
    }
  };
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <GlobalGrid
        id='operation-template'
        columns={theColumns}
        height={'calc(-290px + 100vh)'}
        signalOfLoad={true}
        query={current_query}
        gridRef={onCreated}
        toolbarOptions={toolbarOptions}
        get_query={'asset-cost-estimation'}
        additinalToolbarClick={extendsToolbarClick}
      />
      {showDialog ? (
        <GlobalDialog
          // refDialog={(ref: DialogComponent) => (this.dialog = ref)}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          header={`Operations`}
          width={'80%'}
          height={'60%'}
          hideDoneButton={false}
        >
          <GlobalGrid
            id='operation-template-detail'
            columns={theColumnOperations}
            height={'calc(-600px + 90vh)'}
            signalOfLoad={true}
            query={currentTempId.toString()}
            toolbarOptions={toolbarOptionsForDetail}
            get_query={'operation/template/detail'}
            edit_query={'operation/template/detail/update'}
            add_query={'operation/template/detail/create'}
            delete_query={'operation/template/detail/delete'}
            noNeedPagination={true}
            queryCellInfo={queryCellInfo}
            additionalCrudParams={{ template_id: currentTempId }}
            mapFieldToType={[
              { field: 'required', type: 'string' },
              { field: 'duration', type: 'string' },
              { field: 'est_hours', type: 'string' },
            ]}
          />
        </GlobalDialog>
      ) : null}
    </div>
  );
}

export default OperationTemplate;
